import { render, staticRenderFns } from "./schoolTotal.vue?vue&type=template&id=af724c34&"
import script from "./schoolTotal.vue?vue&type=script&lang=js&"
export * from "./schoolTotal.vue?vue&type=script&lang=js&"
import style0 from "./schoolTotal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports